// Deliberately NOT themed: this mirrors the standalone sign-in page the Pages Function serves for the
// site-wide gate (functions/_middleware.ts → loginHtml) so the two password prompts look identical.
// Keep the two in step when changing either.

.ProtectedLocationGate {
    position: fixed;
    inset: 0;
    z-index: 1000;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 16px;
    box-sizing: border-box;
    background: #0f0f0f;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
    color: #e5e5e5;

    *,
    *::before,
    *::after {
        box-sizing: border-box;
        margin: 0;
        padding: 0;
    }
}

.card {
    width: 100%;
    max-width: 360px;
    padding: 2.5rem 2rem;
    background: #1a1a1a;
    border: 1px solid #2a2a2a;
    border-radius: 12px;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5);
}

.title {
    font-size: 1.4rem;
    font-weight: 600;
    margin-bottom: 1.5rem;
    letter-spacing: -0.02em;
    color: #e5e5e5;
}

.label {
    display: block;
    font-size: 0.8rem;
    font-weight: 500;
    color: #999;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    margin-bottom: 0.4rem;
}

.input {
    width: 100%;
    padding: 0.65rem 0.8rem;
    background: #0f0f0f;
    border: 1px solid #333;
    border-radius: 6px;
    color: #e5e5e5;
    font-size: 1rem;
    font-family: inherit;
    outline: none;
    transition: border-color 0.15s;

    &:focus {
        border-color: #555;
    }
}

.button {
    margin-top: 1.2rem;
    width: 100%;
    padding: 0.7rem;
    background: #e5e5e5;
    color: #0f0f0f;
    border: none;
    border-radius: 6px;
    font-size: 1rem;
    font-family: inherit;
    font-weight: 600;
    cursor: pointer;
    transition: background 0.15s;

    &:hover {
        background: #fff;
    }

    &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }
}

.error {
    margin-top: 1rem;
    padding: 0.6rem 0.8rem;
    background: rgba(220, 38, 38, 0.15);
    border: 1px solid rgba(220, 38, 38, 0.4);
    border-radius: 6px;
    font-size: 0.875rem;
    color: #f87171;
}
